<template>
  <b-modal ref="modal" :title="labels.title" hide-footer no-close-on-backdrop>
    <div v-if="!loading">
      <div class="accordion" role="tablist">
        <b-card
          v-for="(value, idx) in desiredValues"
          :key="`value-${idx}`"
          class="mb-3"
        >
          <b-card-header header-tag="header" class="p-1 d-flex" role="tab">
            <span>
              <b>{{ idx + 1 }}.</b>
              {{ value.name }}
            </span>
            <div class="action-value-options">
              <span v-if="value.isNew" class="text-danger not-saved-value">
                {{ labels.unsaved }}
              </span>
              <i
                v-if="!value.visible"
                @click="$emit('toggleVisibilityDesiredValue', idx)"
                :title="labels.options.btnEdit"
                class="material-icons text-primary clickable mr-1"
              >
                create
              </i>
              <i
                v-if="value.visible"
                :title="labels.options.btnCancel"
                @click="
                  value.isNew
                    ? remove({ idx, ...value })
                    : $emit('toggleVisibilityDesiredValue', idx)
                "
                class="material-icons text-danger clickable mr-1"
              >
                close
              </i>
              <i
                v-if="value.visible && !value.loading"
                :title="labels.options.btnSave"
                @click="save({ idx, ...value })"
                class="material-icons text-success clickable mr-1"
              >
                check
              </i>
              <i
                v-if="value.visible && value.loading"
                class="mdi mdi-loading mdi-spin"
              >
              </i>
              <i
                v-if="!value.visible && !value.loading"
                :title="labels.options.btnRemove"
                @click="remove({ idx, ...value })"
                class="material-icons text-danger clickable mr-1"
              >
                delete
              </i>
              <i
                v-if="!value.visible && value.loading"
                class="mdi mdi-loading mdi-spin"
              >
              </i>
            </div>
          </b-card-header>
          <b-collapse
            :id="`accordion-${idx}`"
            v-model="value.visible"
            accordion="desired-values-accordion"
            role="tabpanel"
            class="p-3"
          >
            <b-form-input
              class="mb-2"
              type="text"
              :value="value.name"
              :placeholder="labels.options.name"
              @update="updateName($event, idx)"
            />
            <treeselect
              ref="treeselect"
              name="culture-values-select"
              :placeholder="labels.options.behaviors"
              :clearAllText="labels.options.cleanSelect"
              :options="values"
              :value="value.cultureValues"
              :multiple="multiple"
              :clearable="clearable"
              :searchable="searchable"
              :open-on-click="openOnClick"
              :open-on-focus="openOnFocus"
              :close-on-select="closeOnSelect"
              :always-open="alwaysOpen"
              valueFormat="object"
              @input="selectValuesChanged($event, idx)"
            >
              <label
                slot="option-label"
                slot-scope="{
                  node,
                  shouldShowCount,
                  count,
                  labelClassName,
                  countClassName,
                }"
                :class="labelClassName"
              >
                <img
                  class="value-image-option"
                  :src="imageUrl.replace('$ID$', node.id)"
                />
                <span :title="node.label">
                  {{ node.label }}
                </span>
                <span v-if="shouldShowCount" :class="countClassName">
                  ({{ count }})
                </span>
              </label>
              <div slot="value-label" slot-scope="{ node }">
                <img
                  class="value-image-option"
                  :src="imageUrl.replace('$ID$', node.id)"
                />
                <span :title="node.label">
                  {{ node.label }}
                </span>
              </div>
            </treeselect>
          </b-collapse>
        </b-card>
      </div>
      <b-button block variant="tertiary" @click="$emit('addDesiredValue')">
        <i class="material-icons">add_circle_outline</i>
        {{ labels.options.btnAdd }}
      </b-button>
      <hr />
      <p class="text-danger text-center">
        {{ labels.alertMessage }}
      </p>
      <div class="text-right">
        <b-button block variant="primary" class="close-button" @click="hide()">
          {{ labels.btnEnd }}
        </b-button>
      </div>
    </div>
    <div v-if="loading">{{ labels.loading }} ...</div>
  </b-modal>
</template>

<script>
import { mapGetters } from 'vuex'
import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'

const props = {
  values: {
    type: Array,
  },
  desiredValues: {
    type: Array,
  },
  imageUrl: {
    type: String,
  },
  loading: {
    type: Boolean,
  },
}

export default {
  props,
  components: {
    Treeselect,
  },
  data() {
    return {
      multiple: true,
      clearable: true,
      searchable: true,
      openOnClick: true,
      openOnFocus: true,
      closeOnSelect: true,
      alwaysOpen: false,
    }
  },
  computed: {
    ...mapGetters({
      resources: 'resources',
    }),
    labels() {
      return this.resources.component.culture.desiredValuesModal
    },
  },
  methods: {
    updateName(name, idx) {
      this.$emit('changeDesiredValueName', { idx, name })
    },
    show() {
      this.$refs.modal.show()
    },
    hide() {
      this.$refs.modal.hide()
    },
    remove(value) {
      this.$emit('removeDesiredValue', value)
    },
    save(value) {
      if (value.isNew) {
        return this.$emit('saveDesiredValue', value)
      }
      this.$emit('updateDesiredValue', value)
    },
    selectValuesChanged(values, idx) {
      this.$emit('selectValuesChanged', { values, idx })
    },
  },
}
</script>

<style scoped lang="scss">
@import '~@/styles/custom/colors';

.d-flex {
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
}

.value-image-option {
  height: 50px;
}

.btn {
  border-radius: 0px !important;
}

.card {
  overflow: visible !important;
  .card-header {
    font-size: 22px;
    .not-saved-value {
      font-size: 16px;
      margin-right: 20px;
      text-transform: uppercase;
    }
  }
  .card-body {
    padding: 0.8rem;
  }
}

.action-value-options {
  font-size: 20pt;
}

.close-button {
  font-size: medium;
  padding-left: 30px;
  padding-right: 30px;
}

/deep/ .vue-treeselect {
  .vue-treeselect__menu {
    color: map-get($theme-colors, 'primary') !important;
    border-radius: 30px !important;
    overflow-x: auto;
  }

  .vue-treeselect__checkbox--checked {
    border-color: map-get($theme-colors, 'primary') !important;
    background: map-get($theme-colors, 'primary') !important;
  }

  .vue-treeselect__control {
    border-radius: 30px !important;
    height: 48px;
  }

  .vue-treeselect__input {
    background: map-get($theme-colors, 'white') !important;
    font-size: 14pt;
  }

  .vue-treeselect__placeholder {
    margin: 7px;
    font-size: 10pt;
  }

  .vue-treeselect__multi-value-item {
    border-radius: 30px !important;
    background-color: map-get($theme-colors, 'gray08');
    color: map-get($theme-colors, 'primary') !important;

    .vue-treeselect__value-remove {
      color: map-get($theme-colors, 'primary') !important;
    }

    .vue-treeselect__multi-value-label {
      white-space: normal;
    }
  }

  .vue-treeselect__label-container {
    &:hover {
      .vue-treeselect__checkbox--unchecked {
        border-color: map-get($theme-colors, 'primary');
      }
    }

    .vue-treeselect__label {
      overflow: inherit;
    }
  }

  .vue-treeselect__option--selected {
    background-color: map-get($theme-colors, 'gray08');
  }
}
</style>
